import React from 'react'

const ThreeDotMenu = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <circle cx="2" cy="2" r="1.625" fill="white" stroke="#215DAA" strokeWidth="0.75" />
            <circle cx="8" cy="2" r="1.625" fill="white" stroke="#215DAA" strokeWidth="0.75" />
            <circle cx="14" cy="2" r="1.625" fill="white" stroke="#215DAA" strokeWidth="0.75" />
        </svg>
    )
}

export default ThreeDotMenu